import React, { FunctionComponent, Fragment } from 'react';
import { Route } from 'react-router-dom';
import { SYSTEM_CONFIGURATION_ROUTE, TARGET_DOMAIN, NETWORK } from '../../constants';
import TargetDomainList from './containers/TargetDomainList';
import TargetDomainCreate from './containers/TargetDomainCreate';
import TargetDomainEdit from './containers/TargetDomainEdit';
import TargetDomainView from './containers/TargetDomainView';

interface Props {
}

const TargetDomain: FunctionComponent<Props> = () => {
  return (
    <Fragment>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${TARGET_DOMAIN}`}>
        <TargetDomainList />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${TARGET_DOMAIN}/create`}>
        <TargetDomainCreate />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${TARGET_DOMAIN}/edit`}>
        <TargetDomainEdit />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${TARGET_DOMAIN}/view`}>
        <TargetDomainView />
      </Route>
    </Fragment>
  );
};

export default TargetDomain;
